module.exports = __webpack_public_path__ + "static/media/home_phone1.d612dd27.png";